import { SUPPRESS_SUCCESS_GROWL } from 'utils/constants';
import { GENERATE_AUDIO_ACTIONS } from './actions/Creatives';

export function loadVoiceSettings() {
	return (dispatch) => {
		return dispatch({
			type: GENERATE_AUDIO_ACTIONS.LOAD_VOICE_SETTINGS,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: 'ai',
				url: `ui/audio/voice-parameters`,
				success: '',
				error: '',
			},
		});
	};
}

export function loadVoices(params = {}) {
	return (dispatch) => {
		return dispatch({
			type: GENERATE_AUDIO_ACTIONS.LOAD_VOICES,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: 'ai',
				url: `ui/audio/voices`,
				params: { ...params, pageSize: 100 },
				success: '',
				error: '',
			},
		});
	};
}

export function loadSoundSettings() {
	return (dispatch) => {
		return dispatch({
			type: GENERATE_AUDIO_ACTIONS.LOAD_SOUND_SETTINGS,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: 'ai',
				url: `ui/audio/sound-parameters`,
				success: '',
				error: '',
			},
		});
	};
}

export function loadSoundMoods() {
	return (dispatch) => {
		return dispatch({
			type: GENERATE_AUDIO_ACTIONS.LOAD_SOUND_MOODS,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: 'ai',
				url: `ui/audio/sound-moods`,
				success: '',
				error: '',
			},
		});
	};
}

export function loadSounds(params = {}) {
	return (dispatch) => {
		return dispatch({
			type: GENERATE_AUDIO_ACTIONS.LOAD_SOUNDS,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: 'ai',
				url: `ui/audio/sounds`,
				params: { ...params, pageSize: 100 },
				success: '',
				error: '',
			},
		});
	};
}

export function createAudioVersions(data) {
	return (dispatch) => {
		return dispatch({
			type: GENERATE_AUDIO_ACTIONS.CREATE_VERSIONS,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: 'ai',
				url: 'ui/audio/create-versions',
				method: 'post',
				data: { numberOfVersions: 3, ...data },
				success: '',
				error: '',
			},
		});
	};
}

export function generateAudio(data) {
	return (dispatch) => {
		return dispatch({
			type: GENERATE_AUDIO_ACTIONS.GENERATE_AUDIO,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				gateway: 'ai',
				url: 'ui/audio/generate',
				method: 'post',
				data,
				success: '',
				error: '',
			},
		});
	};
}
